rdefine('app/components/TableBJS', ['backbone'], function(Backbone) {

    var ColumnView = Backbone.Ribs.View.extend({
        tagName:'th',
        className:'fig',
        bindings:{
            el:{
                text:'model.title',
                classes:{
                  /*  'sorting':{
                        data:['model.type','model.sorting','model.direction'],
                        processor: function(type, sorting, direction) {
                            if(type==='icon') {
                                return false;
                            }
                            return !sorting;
                        }
                    },
                    'sorting_asc':{
                        data:['model.type','model.sorting','model.direction'],
                        processor: function(type, sorting, direction) {
                            if(type==='icon') {
                                return false;
                            }
                            return sorting && direction==='asc';
                        }
                    },
                    'sorting_desc':{
                        data:['model.type','model.sorting','model.direction'],
                        processor: function(type, sorting, direction) {
                            if(type==='icon') {
                                return false;
                            }
                            return sorting && direction==='desc';
                        }
                    }*/
                }
            }
        },
        events:{
            "click":"onSortChange"
        },
        initialize:function() {

        },
        onSortChange: function() {
            var type = this.model.get('type');
            if(type!=='icon') {
             //   this.collection.trigger('resort', this.model);
            }
        }
    });

    var ValueView = Backbone.Ribs.View.extend({
        tagName:'td',
        bindings:{
            el:{

            }
        },
        initialize:function(opts) {
            this.data = opts.data;
            this.bindings.el.text = {data:'data.'+this.model.get('field')};
            if(this.model.has('processor')) {
                this.bindings.el.text.processor = this.model.get('processor');
            }
        }
    });
    var ActionView = Backbone.Ribs.View.extend({
        tagName:'td',
        bindings:{
            '.zmdi':{
                mod:{
                    'zmdi-': 'model.icon'
                }
            },
            '.btn':{
                mod:{
                    'btn-':'model.color'
                }
            }
        },
        events:{
            "click":"onClick"
        },
        data:null,
        initialize:function(opts){
            this.data = opts.data;
            this.$el.html('<button type="button" class="btn btn-icon"><span class="zmdi"></span></button>');
        },
        onClick:function(){
            if(this.model.has("action") && typeof this.model.get("action")==='function') {
                this.model.get('action')(this.data);
            }
        }
    });

    var RowView = Backbone.Ribs.View.extend({
        tagName:'tr',
        className:'',
        columns:null,
        bindings:{},
        initialize: function(options){
            this.preventBindings();
            this.columns = this.model.collection.columns;
            var self = this;
            this.bindings.el={
                collection: {
                    col:'columns',
                    view: function(options) {
                        var type = options.model.get('type','view');
                        options.data = self.model;
                        if(type=='icon') {
                            return new ActionView(options);
                        }

                        return new ValueView(options);
                    }
                }
            };
            this.applyBindings(this.bindings);
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'table',
        currentSort: 'created_at',
        currentDirection:'asc',
        className:'table table-striped dataTable',
        columns:null,
        bindings:{
            'thead':{
                collection:{
                    col:'columns',
                    view:ColumnView
                }
            },
            'tfoot':{
                collection:{
                    col:'columns',
                    view:ColumnView
                }
            },
            'tbody':{
                collection:{
                    col:'collection',
                    view: RowView
                }
            }
        },

        initialize:function(options) {
            this.$el.html('<thead></thead><tfoot></tfoot><tbody></tbody>');
            this.currentSort = options.sort || 'created_at';
            this.currentDirection = options.direction || 'asc';
            this.processor = function(a) {
                return a;
            };
            var self = this;
           /* this.collection.comparator= function(a,b) {
                var av = self.processor(a.get(self.currentSort)).toString();
                var bv = self.processor(b.get(self.currentSort)).toString();
                console.log(self.currentSort, av,bv);

                if((this.currentDirection==='asc' && av>bv) || (this.currentDirection==='desc' && av<bv)) {
                    console.log(-1);
                    return 1;
                }else if((this.currentDirection==='asc' && av<bv) || (this.currentDirection==='desc' && av>bv)){
                    console.log(1);
                    return -1
                }
                console.log(0);
                return 0;
            }.bind(this);*/

            this.columns = new Backbone.Ribs.Collection(options.columns || [], {
                model: Backbone.Ribs.Model
            });
            this.collection.columns = this.columns;

            this.columns.csrt = this.currentSort;
            this.columns.each(function(column) {
                if(column.field === this.currentSort) {
                    column.set({sorting:true, direction:this.currentDirection});
                }
            }.bind(this));
            //this.collection.sort();
            this.columns.on('resort', this.resort.bind(this));
        },
        resort: function(model) {
            this.columns.each(function(column) {
                column.set({sorting:false, direction:'asc'});
            });

            if(model.get('field')===this.currentSort) {
                this.currentDirection = this.currentDirection==='asc' ? 'desc' : 'asc';
            }else{
                this.currentDirection = 'asc';
            }

            this.currentSort = model.get('field');
            model.set({sorting: true, direction: this.currentDirection});
            if(model.has('processor')) {
                this.processor = model.get('processor');
            }else{
                this.processor = function(a) { return a; }
            }
            //this.collection.sort();
        }
    });
});